(function () {
  var root = document.querySelector('[data-gb-green]');
  if (!root) return;

  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-gb-green-row]'));
  var chips = Array.prototype.slice.call(root.querySelectorAll('[data-gb-green-filter]'));
  var empty = root.querySelector('[data-gb-green-empty]');

  function sackKgOf(row) {
    return parseInt(row.getAttribute('data-sack-kg'), 10) || 0;
  }

  function sackPriceOf(row) {
    var pence = parseInt(row.getAttribute('data-sack-price'), 10);
    if (isFinite(pence) && pence > 0) return pence / 100;
    return sackKgOf(row) * (parseFloat(row.getAttribute('data-price')) || 0);
  }

  function pounds(n) {
    return window.GBCart.moneyFloat(n);
  }

  function activeFilters() {
    var active = {};
    chips.forEach(function (chip) {
      if (chip.getAttribute('aria-pressed') !== 'true') return;
      var group = chip.getAttribute('data-gb-green-filter');
      (active[group] = active[group] || []).push(chip.getAttribute('data-value'));
    });
    return active;
  }

  function matches(row, active) {
    if (active.status && active.status.indexOf(row.getAttribute('data-status')) === -1) return false;
    if (active.variety && active.variety.indexOf(row.getAttribute('data-variety')) === -1) return false;
    if (active.process) {
      // Exact: a lot has one method, so "washed" never matches a Washed Anaerobic lot.
      if (active.process.indexOf(row.getAttribute('data-process') || '') === -1) return false;
    }
    if (active.score) {
      var score = parseFloat(row.getAttribute('data-score'));
      if (!(score >= parseFloat(active.score[0]))) return false;
    }
    return true;
  }

  function applyFilters() {
    var active = activeFilters();
    var activeCount = Object.keys(active).reduce(function (n, k) { return n + active[k].length; }, 0);
    var shown = 0;
    rows.forEach(function (row) {
      var ok = matches(row, active);
      row.hidden = !ok;
      if (ok) shown++;
    });
    if (empty) empty.hidden = shown > 0;
    var emptyTitle = root.querySelector('[data-gb-green-empty-title]');
    if (emptyTitle) {
      emptyTitle.textContent = activeCount > 1 ? 'No lot matches those filters.' : 'No lot matches that filter.';
    }
    var count = root.querySelector('[data-gb-green-count]');
    if (count) {
      count.textContent = activeCount > 0 ? shown + ' of ' + rows.length + ' lots' : rows.length + ' lots';
    }
    root.querySelectorAll('.gb-green__count-clear').forEach(function (btn) {
      btn.hidden = activeCount === 0;
    });
    totalOrder();
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var group = chip.getAttribute('data-gb-green-filter');
      var pressed = chip.getAttribute('aria-pressed') === 'true';
      if (!pressed && group !== 'process') {
        chips.forEach(function (other) {
          if (other !== chip && other.getAttribute('data-gb-green-filter') === group) {
            other.setAttribute('aria-pressed', 'false');
          }
        });
      }
      chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
      applyFilters();
    });
  });

  root.querySelectorAll('[data-gb-green-clear]').forEach(function (clear) {
    clear.addEventListener('click', function () {
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', 'false');
      });
      applyFilters();
    });
  });

  var sortState = { key: null, dir: 1 };
  function rowSortValue(row, key) {
    if (key === 'score') return parseFloat(row.getAttribute('data-score')) || 0;
    if (key === 'price') return parseFloat(row.getAttribute('data-price')) || Infinity;
    var total = parseInt(row.getAttribute('data-total-kg'), 10);
    if (isFinite(total) && total > 0) return total;
    return (parseInt(row.getAttribute('data-max'), 10) || 0) * sackKgOf(row);
  }
  var sortPick = root.querySelector('[data-gb-green-sort-pick]');
  var SORT_LABELS = {
    'score:1': 'Score, low to high',
    'price:-1': 'Price per kg, high to low',
    'kg:1': 'Least available'
  };
  function applySort(key, dir) {
    sortState.key = key;
    sortState.dir = dir;
    var table = root.querySelector('.gb-green__table');
    var anchor = root.querySelector('[data-gb-green-empty]');
    var order = rows.slice();
    if (key) order.sort(function (a, b) { return (rowSortValue(a, key) - rowSortValue(b, key)) * dir; });
    order.forEach(function (row) { table.insertBefore(row, anchor); });
    root.querySelectorAll('[aria-sort]').forEach(function (h) {
      var mine = key && h.querySelector('[data-gb-green-sort="' + key + '"]');
      h.setAttribute('aria-sort', mine ? (dir === 1 ? 'ascending' : 'descending') : 'none');
    });
    // The phone menu and the desktop headers are one sort; keep them telling the same story.
    // A header can reverse a sort the menu doesn't list, so that option is added on demand.
    if (sortPick) {
      var v = key ? key + ':' + dir : '';
      if (v && !sortPick.querySelector('option[value="' + v + '"]')) {
        var o = document.createElement('option');
        o.value = v;
        o.textContent = SORT_LABELS[v] || v;
        sortPick.appendChild(o);
      }
      sortPick.value = v;
    }
  }
  root.querySelectorAll('[data-gb-green-sort]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.getAttribute('data-gb-green-sort');
      applySort(key, sortState.key === key ? -sortState.dir : (key === 'price' ? 1 : -1));
    });
  });
  if (sortPick) {
    sortPick.addEventListener('change', function () {
      var parts = sortPick.value.split(':');
      applySort(parts[0] || null, parseInt(parts[1], 10) || 1);
    });
  }

  function rowQty(row) {
    var el = row.querySelector('[data-gb-qty]');
    if (!el) return 0;
    // Clamp on READ: a mid-typing value beyond the sacks in stock must never inflate totals.
    var max = parseInt(row.getAttribute('data-max'), 10) || 0;
    var q = parseInt(el.value, 10) || 0;
    if (q < 0) q = 0;
    if (max > 0 && q > max) q = max;
    return q;
  }

  function syncStepper(row) {
    var qty = rowQty(row);
    var max = parseInt(row.getAttribute('data-max'), 10) || 0;
    row.setAttribute('data-qty', String(qty));
    var minus = row.querySelector('[data-step="-1"]');
    var plus = row.querySelector('[data-step="1"]');
    var disMinus = qty <= 0;
    var disPlus = max > 0 && qty >= max;
    if (minus && disMinus && document.activeElement === minus && plus) plus.focus();
    if (plus && disPlus && document.activeElement === plus && minus) minus.focus();
    if (minus) minus.disabled = disMinus;
    if (plus) plus.disabled = disPlus;
  }


  function totalOrder() {
    var sacks = 0;
    var kg = 0;
    var subtotal = 0;
    rows.forEach(function (row) {
      if (row.hidden) return;
      var qty = rowQty(row);
      if (qty) {
        sacks += qty;
        kg += qty * sackKgOf(row);
        subtotal += qty * sackPriceOf(row);
      }
    });
    var set = function (sel, text) {
      var el = root.querySelector(sel);
      if (el) el.textContent = text;
    };
    // Green order quantities read in kilos, not bag-count.
    var lots = 0;
    rows.forEach(function (row) {
      if (!row.hidden && rowQty(row) > 0) lots++;
    });
    set('[data-gb-order-count]', kg + 'kg · ' + lots + ' lot' + (lots === 1 ? '' : 's'));
    set('[data-gb-order-subtotal]', pounds(subtotal));
    set('[data-gb-order-total]', pounds(subtotal));
    var parkedKg = 0;
    var parkedLots = 0;
    rows.forEach(function (row) {
      if (!row.hidden) return;
      var q = rowQty(row);
      if (q > 0) {
        parkedKg += q * sackKgOf(row);
        parkedLots++;
      }
    });
    var parked = root.querySelector('[data-gb-green-parked]');
    if (parked) {
      parked.hidden = parkedKg === 0;
      if (parkedKg > 0) {
        parked.textContent = parkedKg + 'kg (' + parkedLots + ' lot' + (parkedLots === 1 ? '' : 's') + ') on filtered-out lots — not in this order. Clear the filters to include them.';
      }
    }
    var place = root.querySelector('[data-gb-order-place]');
    if (place) place.disabled = sacks === 0 || subtotal <= 0;
  }

  rows.forEach(function (row) {
    var stepper = row.querySelector('[data-gb-stepper]');
    if (!stepper) return;
    stepper.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-step]');
      if (!btn || btn.disabled) return;
      var el = row.querySelector('[data-gb-qty]');
      var max = parseInt(row.getAttribute('data-max'), 10) || 0;
      var next = rowQty(row) + parseInt(btn.getAttribute('data-step'), 10);
      if (next < 0) next = 0;
      if (max > 0 && next > max) next = max;
      el.value = String(next);
      syncStepper(row);
      totalOrder();
    });
    var qtyInput = row.querySelector('[data-gb-qty]');
    if (qtyInput) {
      // Typed quantities: soft-update while typing (rowQty clamps the read); normalize
      // the field only on change/blur so we never rewrite mid-keystroke.
      qtyInput.addEventListener('input', function () { syncStepper(row); totalOrder(); });
      qtyInput.addEventListener('change', function () { qtyInput.value = String(rowQty(row)); syncStepper(row); totalOrder(); });
    }
    syncStepper(row);
  });

  // Quote-first (2026-09-01): the selection goes to /pages/request-a-quote in the
  // query string (survives refresh and back); titles and shown prices ride
  // sessionStorage for the summary. The server reprices at submit.
  var place = root.querySelector('[data-gb-order-place]');
  if (place) {
    place.addEventListener('click', function () {
      if (place.disabled) return;
      var lines = [];
      rows.forEach(function (row) {
        if (row.hidden) return;
        var qty = rowQty(row);
        var lot = row.getAttribute('data-lot-number');
        if (qty > 0 && lot) {
          lines.push({
            lotNumber: lot,
            size: sackKgOf(row) + 'kg',
            title: row.getAttribute('data-title') || lot,
            pence: Math.round(sackPriceOf(row) * 100),
            quantity: qty
          });
        }
      });
      if (lines.length === 0) return;
      var error = root.querySelector('[data-gb-order-error]');
      if (lines.length > 20) {
        if (error) {
          error.textContent = 'Up to 20 lots per request — trim the list and send the rest in a second request.';
          error.hidden = false;
        }
        return;
      }
      if (error) error.hidden = true;
      var display = {};
      lines.forEach(function (l) { display[l.lotNumber + '~' + l.size] = { title: l.title, pence: l.pence }; });
      try { sessionStorage.setItem('gb_quote_display', JSON.stringify(display)); } catch (e) {}
      var linesParam = lines.map(function (l) { return l.lotNumber + '~' + l.size + '~' + l.quantity; }).join(',');
      window.location.href = '/pages/request-a-quote?channel=green&lines=' + encodeURIComponent(linesParam);
    });
  }

  applyFilters();
  totalOrder();
})();
